import React, { useState, useEffect, useRef } from "react";
import "../../assets/css/new-website.css"
import Footer from "../layout/footerUpdated";
import Header from "../layout/headerHome";
import FAQComponent from '../element/component/faq';
import WhyLab from '../element/component/whyLab';
import TestimonialSlider from "../element/component/testimonial-slider";
import ReachToUsForm from "../element/ReachToUsForm";
import Popup_Main from "../element/component/Popup_Main";


const AdultVaccines = () => {

  const [isOpen, setIsOpen] = useState(false);
  const Counter = ({ targetValue, duration }) => {
    const [count, setCount] = useState(0);
    const [isAnimating, setIsAnimating] = useState(false);
  
    useEffect(() => {
      let startValue = 0;
      const increment = targetValue / (duration / 50);
  
      const updateCounter = () => {
        startValue += increment;
        if (startValue >= targetValue) {
          setCount(Math.ceil(targetValue));
          setIsAnimating(false); // End animation
        } else {
          setCount(Math.floor(startValue));
          setIsAnimating(true); // Start animation
          requestAnimationFrame(updateCounter);
        }
      };
  
      setIsAnimating(true); // Initialize animation
      updateCounter();
    }, [targetValue, duration]);
  
    return <h3 className={isAnimating ? "animate-counter" : ""}>{count}%</h3>;
  };
  

const whyData = [
    { title: "Doctor-Guided Recommendations", desc: "Understand which vaccinations are relevant based on your age, health and history.", image: "/images/new-website/adult-vaccines/doctor-instruction.webp" },
    { title: "Multiple Vaccines in One Place", desc: "Access routine, age-based and travel vaccinations through Bridge Health.", image: "images/new-website/adult-vaccines/multiple-vaccines.webp" },
    { title: "Vaccination Records & Follow-Up", desc: "Receive guidance on future doses and vaccination schedules where required.", image: "/images/new-website/adult-vaccines/vaccination-record.webp" },
    { title: "Convenient Access", desc:"Choose a nearby Bridge Health clinic, with at-home vaccination whereever available.", image: "/images/new-website/adult-vaccines/clinic-access.webp" },
];

  const vaccines = [
  {
    title: "HPV Vaccine",
    subtitle: "Protect Against HPV-Related Disease",
    image: "/images/new-website/adult-vaccines/hpv-vaccines.webp",
    icon: "/images/new-website/adult-vaccines/hpv-young.webp",
    description:
      "HPV vaccination helps protect against HPV types that can cause cervical cancer and other HPV-related cancers and disease.",
    bestConsidered:
      "Adolescents and young adults, with vaccination for selected adults depending on age and individual doctor guidance.",
    buttonText: "Ask About HPV Vaccination",
  },
  {
    title: "Shingles Vaccine",
    subtitle: "Protect Against Shingles & Its Complications",
    image: "/images/new-website/adult-vaccines/shingle-vaccine.webp",
    icon: "/images/new-website/adult-vaccines/adult-shingles.webp",
    description:
      "Shingles is caused by reactivation of the virus that causes chickenpox and can lead to a painful rash and long-lasting nerve pain. Vaccination can help reduce the risk.",
    bestConsidered:
      "Adults 50+ and certain younger adults with increased risk, based on medical guidance.",
    buttonText: "Ask About Shingles Vaccination",
  },
  {
    title: "Influenza Vaccine",
    subtitle: "Stay Protected Through Flu Season",
    image: "/images/new-website/adult-vaccines/influenza.webp",
    icon: "/images/new-website/adult-vaccines/influenze-all.webp",
    description:
      "Annual influenza vaccination helps reduce the risk of flu and its potentially serious complications, particularly for people at higher risk.",
    bestConsidered:
      "Adults of all ages, especially older adults, pregnant women and people with chronic health conditions.",
    buttonText: "Ask About Flu Vaccination",
  },
];

  const hearingSigns = [
  {
    title: "Difficulty Following Conversations",
    icon: "/images/new-website/adult-vaccines/doctor-guidance-vaccines.webp",
  },
  {
    title: "Frequently Asking People to Repeat",
    icon: "/images/new-website/adult-vaccines/risk-guidance.webp",
  },
  {
    title: "Increasing TV or Phone Volume",
    icon: "/images/new-website/adult-vaccines/mulitple-adult-vaccines.webp",
  },
  {
    title: "Changes in One or Both Ears",
    icon: "/images/new-website/adult-vaccines/convenient-clinic.webp",
  },
];


    const BloodTestsettings = {
      dots: true, 
      infinite: true, 
      speed: 7000, 
      slidesToShow: 3, 
      slidesToScroll: 1,
      autoplay: true, 
      autoplaySpeed: 3000, 
      responsive: [
  
        {
          breakpoint: 768, // Mobile view
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            centerMode: false,

          },
        },
      ],
    };

    const yogaTypes = [
        {
            name: "Women’s Health Vaccinations",
            desc: "Vaccination guidance across different life stages, including HPV and other vaccines recommended based on age, pregnancy planning and individual health needs.",
            image: "/images/new-website/adult-vaccines/women-vaccines.webp",
          },
          {
            name: "Vaccinations for Adults 50+",
            desc: "Preventive vaccination including shingles, influenza and pneumococcal vaccination based on age and health risk.",
            image: "/images/new-website/adult-vaccines/senior-citizen-vaccines.webp",
          },
          {
            name: "Travel and Routine Vaccinations",
            desc: "Vaccinations based on your destination, planned activities, previous immunisation history and everyday preventive needs.",
            image: "/images/new-website/adult-vaccines/travel-immunization.webp",
          },
    
      ];

  const testimonials = [
    {
      content:
        "Bridge health offers services at affordable cost. Akshata at the front desk is very cooperative and good at coordinating and follow-ups. The staff are well spoken and carried out all tests with patience.",
      name: "Akshata J Lokhande",
      image: "/images/new-website/bridgehealth-icon-new.webp", // Replace with actual image URL
    },
    {
      content:
        "I am Prof Sundararaj living at PRIMUS REFLECTION. The staff are very courteous with a smile on their faces, including all the doctors. Special thanks to Ms. Akshita!",
      name: "Sundar Raj",
      image: "/images/new-website/bridgehealth-icon-new.webp", // Replace with actual image URL
    },
    {
      content:
        "Good , clean hygiene place ... Feels like your are at home with the services that provide... I have enrolled for gym here.. And the trainers are thorough professionals.. And the staff I have interacted with them during the seminars or presentations they are knowledgeable",
      name: "Shiva Kumar S",
      image: "/images/new-website/bridgehealth-icon-new.webp", // Replace with actual image URL
    },
    {
      content:
        "From sattva apartment Bridge healthy is useful for our patients.Mahendra the nursing staff is good and courteous.",
      name: "Susheela Sharan",
      image: "/images/new-website/bridgehealth-icon-new.webp", // Replace with actual image URL
    },
    {
      content:
        "Laxman is an excellent nurse looking after the retired community. Gentle in taking blood. Very polite and efficient.",
      name: "Dipak Rao",
      image: "/images/new-website/bridgehealth-icon-new.webp", // Replace with actual image URL
    },
  ];

  const faqs = [
    {
      question: "Do adults really need vaccinations? ",
      answer:
        "Yes. Vaccine recommendations can continue throughout adulthood and may change according to age, previous vaccination, medical conditions, pregnancy, occupation and travel.",
    },
    {
      question: "How do I know which vaccines I have already received?",
      answer: "Bring any available vaccination records. If your history is unclear, a healthcare professional can review what is known and advise you on appropriate next steps.",
    },
    {
      question: "Can men get the HPV vaccine?",
      answer: "Yes. HPV vaccination is relevant to both males and females because HPV can cause several cancers and other HPV-related disease. (World Health Organization)",
    },
    {
      question: "Who should consider shingles vaccination?",
      answer: "Shingles vaccination is commonly recommended for adults aged 50 and older. Certain younger adults with weakened immunity may also be advised vaccination. (CDC)",
    },
    {
      question: "Do I need a flu vaccine every year?",
      answer: "Yes, annual influenza vaccination is recommended because immune protection decreases over time and circulating influenza viruses change. (CDC)",
    },
    {
      question: "Can I take more than one vaccine at the same visit?",
      answer: "Some vaccines can be administered during the same visit at different injection sites, but this depends on the vaccines and your individual health circumstances. Your healthcare professional will advise you.",
    },
    {
      question: "Are vaccinations available at home?",
      answer: "Bridge Health currently promotes convenient at-home vaccination services; availability should be shown by location when the user books. (Bridge Health)"
    }
    ];


  const [isMobile, setIsMobile] = useState(false);
  const sectionRefs = useRef([]); // Refs for multiple sections/cards
  const [hasAnimated, setHasAnimated] = useState([]); // Animation tracking for cards

  // Resize event listener to detect mobile view
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    handleResize(); // Initialize on mount
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Scroll Animation Logic
  useEffect(() => {
    const handleScroll = () => {
      const updatedVisibility = sectionRefs.current.map((ref) => {
        if (ref) {
          const rect = ref.getBoundingClientRect();
          const windowHeight =
            window.innerHeight || document.documentElement.clientHeight;

          // Element becomes visible when its top is within viewport
          return rect.top <= windowHeight - 50;
        }
        return false;
      });

      setHasAnimated((prev) =>
        updatedVisibility.map((visible, index) => prev[index] || visible)
      );
    };

    window.addEventListener("scroll", handleScroll);
    handleScroll(); // Trigger on mount to check initial visibility
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const tests = [
    {
      icon: "/images/blood-test.webp",
      title: "HPV Vaccine- Gardasil 9 PFS",
      testsIncluded: "Protects against strains of human papillomavirus causing cervical, anal, mouth, and throat cancers. ",
      price: "₹10360",
      for: "Men, Women",
      start: "Starts"
    },
     {
      icon: "/images/blood-test.webp",
      title: "HPV Vaccine- Gardasil 4 PFS",
      testsIncluded: "Protects against strains of human papillomavirus causing cervical, anal, mouth, and throat cancers. ",
      price: "₹3927",
      for: "Men, Women",
      start: "Starts"
    },
    {
      icon: "/images/sugar-blood-test.webp",
      title: "Tdap or Td Vaccine",
      testsIncluded: "Shields against tetanus, diphtheria, and whooping cough, critical for prenatal and postpartum health.",
      price: "₹1538",
      for: "Women",
      start: "Starts"
    },
    {
      icon: "/images/kidney-test.webp",
      title: "Herpes Zoster/Shingles Vaccine",
      testsIncluded: "Prevents painful shingles rash and long-term nerve complications. ",
      price: "₹9990",
      for: "Older Adults",
      start: "Starts"
    },
    {
      icon: "/images/kidney-test.webp",
      title: "Pneumococcal Vaccine",
      testsIncluded: "Protects older adults from pneumonia, blood infections, and meningitis. ",
      price: "₹2525",
      for: "Older Adults",
      start: "Starts"
    },

    {
      icon: "/images/kidney-test.webp",
      title: "Influenza Vaccine",
      testsIncluded: "Defends against the flu, a highly contagious virus causing respiratory illnesses. ",
      price: "₹2688",
      for: "Men, Women",
      start: "Starts"
    },

    {
      icon: "/images/kidney-test.webp",
      title: "Typhoid Vaccine",
      testsIncluded: "Protects individuals from typhoid fever caused by contaminated food and water.",
      price: "₹2622",
      for: "All",
      start: "Starts"
    },

    {
      icon: "/images/kidney-test.webp",
      title: "Chicken Pox",
      testsIncluded: "Provides immunity against chickenpox infection and reduces severity of related symptoms",
      price: "₹2500",
      for: "All",
      start: "Starts"
    },

    {
      icon: "/images/kidney-test.webp",
      title: "Meningococcal",
      testsIncluded: "Protects against meningococcal bacteria causing meningitis and severe bloodstream infections.",
      price: "₹4433",
      for: "All",
      start: "Starts"
    },
  ];

  return (
    <div>
      <Header/>
      <div className={`landingcontainerAudio ${isMobile ? "mobile" : ""}`}>
        <div className={`leftContainerAudio ${isMobile ? "mobile" : ""}`}>
          <h1 className="first-section-heading-audio">
          Adult Vaccinations for Protection at <span className="highlight1"> Every Stage of Life</span> 
          </h1>
          <p className="paragraph-left">Stay protected against vaccine-preventable infections with doctor-guided vaccination for HPV, shingles, influenza and other adult health needs.</p>
          <button className="buttonlanding" onClick={()=>setIsOpen(true)}>Know More</button>
        </div>
        <div className="rightContainerAudio">
          <img
            src="/images/new-website/adult-vaccines/adult-vaccine-landing-banner.webp"
            alt="adult-vaccine-landing"
            className="adult-vaccine-landing imageFadeInUp"
          />
        </div>
      </div>

    <section>
        <div className="yoga-types-adult">
          <div className="adultvaccineabout">
            <p className="dental-text-gentle">Vaccination remains important throughout adulthood. The vaccines you may need depend on your age, previous vaccinations, health conditions, lifestyle and travel. Bridge Health provides doctor-guided adult vaccination, including HPV, shingles and seasonal influenza vaccines, with personalised guidance to help you understand which vaccinations may be appropriate for you. </p>
          </div>
          
        </div>
    </section>  

    <section>
        <div className={`strongcontainer-adult ${isMobile ? "mobile" : ""}`}>
          <div className="adultvaccineabout">
            <h2 className="heading1">
            Which 
              <span className="highlight1">  Adult Vaccines</span> Should You Know About?
            </h2>
              <div className="adult-vaccines-container">

                {/* Vaccine Cards */}
                <div className="vaccine-grid">
                  {vaccines.map((vaccine, index) => (
                    <article className="vaccine-card" key={index}>

                      {/* Image */}
                      <div className="vaccine-image">
                        <img
                          src={vaccine.image}
                          alt={vaccine.title}
                        />
                      </div>

                      {/* Content */}
                      <div className="vaccine-content">

                        <h3 className="vaccine-title">
                          {vaccine.title}
                        </h3>

                        <h4 className="vaccine-subtitle">
                          {vaccine.subtitle}
                        </h4>

                        <p className="vaccine-description">
                          {vaccine.description}
                        </p>

                        {/* Best Considered */}
                        <div className="best-considered">

                          <img
                            className="best-icon"
                            src={vaccine.icon}
                            alt=""
                          />

                          <div className="best-content">
                            <strong>Best considered:</strong>

                            <p>
                              {vaccine.bestConsidered}
                            </p>
                          </div>

                        </div>

                        <button className="buttonlanding" onClick={()=>setIsOpen(true)}>{vaccine.buttonText}</button>

                      </div>
                    </article>
                  ))}
                </div>

              </div>
          </div>
        </div>
    </section>

    <section>
        <div className="yoga-types-adult">
          <div className="rightstrongcontainer">
            <h2 className="heading1">
              <span className="highlight1">Which Vaccines </span>
              <span className="line-break-heading"><br /></span> Could Be Relevant to You?
            </h2>
          </div>
          <div className="yoga-type-card-section">
                {yogaTypes.map((yoga, index) => (
                    <div
                    key={index}
                    className="adult-type-card"
                    >
                    <img src={yoga.image} alt={yoga.name} className="leadership-image" />
                    <div className="physio-types-desc">
                    <h3 className="solutiontext"><span className="solutionbold">{yoga.name.split(" ")[0]}</span>{" "}
                    {yoga.name.split(" ").slice(1).join(" ")}</h3>
                    <p className="yoga-type-desc">{yoga.desc}</p>
                    </div>
                    </div>
                ))}
          </div>
        </div>
    </section>  


      <section className="why-choose-section-adult">
          <h2 className="heading1">Why Choose <span className="highlight1">Bridge Health</span> for Adult Vaccination in Bangalore</h2>
                    
          <WhyLab
            whyData={whyData} 
            dynamicText="Radiology" 
            dynamicParagraph="We have some of the best specialists who bring years of experience and offer evidence – based treatment to ensure best care for you" 
          />
      </section>
      
    <section>
        <div>
        <FAQComponent faqs={faqs} />
        </div>
    </section>

    <section>
    <div className="testimonials-container">
      {/* Left Side */}
      <div className="left-section-testimonial">
        <h2>
        Trust Us Based on What Our <span className="highlight1">Patrons Say</span>
        </h2>
        <h3>Overall Ratings</h3>
        <div className="ratings">
          <img
            src="/images/new-website/women-care/google-logo-1.webp"
            alt="Google Logo"
          />
          <div>
            <p>
              4.9{" "}
              <span className="stars">
                ⭐⭐⭐⭐⭐
              </span>
            </p>
            <p>Customer Reviews</p>
          </div>
        </div>
        <a href="https://g.page/r/CagLkxSu4CfZEBM/review" target="_blank" rel="noopener noreferrer">
        <button className="buttonmaphome-review">Write a Review</button>
        </a>
      </div>

      {/* Right Side */}
      <div className="right-section-testimonial">
        <div className="testimonial-page">
      <TestimonialSlider testimonials={testimonials} />
    </div>
      </div>
    </div>
    </section>
        <Popup_Main isOpen={isOpen} onClose={() => setIsOpen(false)} >
        <ReachToUsForm submitted={() => setIsOpen(false)} />
        </Popup_Main>
        <Footer />
    </div>
  );
};

export default AdultVaccines;
